var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "priorityModal",
        title: "Update Rate Type",
        "modal-class": "priority-modal",
        centered: "",
        "hide-footer": "",
        size: "md",
      },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _vm.loading ? _c("spinner-loader") : _vm._e(),
      _vm._v(" "),
      _c(
        "b-form",
        { staticClass: "pricing-rate-form" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { sm: "12" } },
                [
                  _c(
                    "info-row",
                    {
                      staticClass: "info-main-row py-2",
                      attrs: { title: "Rate Type", sizing: 3 },
                    },
                    [
                      _c("b-form-select", {
                        staticClass: "form-control",
                        attrs: {
                          required: "",
                          options: _vm.rateTypes,
                          state: _vm.fieldState.priority,
                        },
                        model: {
                          value: _vm.form.priority,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "priority", $$v)
                          },
                          expression: "form.priority",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mx-0 mt-2" },
        [
          _c(
            "b-col",
            { staticClass: "px-2", attrs: { xs: "6" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "my-2 w-100",
                  attrs: { variant: "success" },
                  on: { click: _vm.saveRule },
                },
                [_vm._v("\n        Save\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "px-2", attrs: { xs: "6" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "my-2 w-100",
                  attrs: { variant: "danger" },
                  on: { click: _vm.hide },
                },
                [_vm._v("\n        Close\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }